import { withProps } from "recompose";

export const scrollDestinationId = "scroll-destination";

export default withProps({ id: scrollDestinationId })("span");
